import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import MobileTopBar from '../components/MobileTopBar';
import { ChevronLeft } from 'lucide-react';
import AIInterviewerTab from '../components/settings/AIInterviewerTab';
import APIAccessTab from '../components/settings/APIAccessTab';
import GeneralTab from '../components/settings/GeneralTab';
import ApplicationFormTab from '../components/settings/ApplicationFormTab';
import EmailNotificationsTab from '../components/settings/EmailNotificationsTab';
import EmailTemplatesTab, { JobsTab } from '../components/settings/EmailTemplatesTab';

const TABS = [
  { id: 'ai-interviewer', label: 'AI interviewer', Component: AIInterviewerTab },
  { id: 'api-access', label: 'API access', Component: APIAccessTab },
  { id: 'general', label: 'General', Component: GeneralTab },
  { id: 'jobs', label: 'Jobs', Component: JobsTab },
  { id: 'application-form', label: 'Application form', Component: ApplicationFormTab },
  { id: 'email-notifications', label: 'Email notifications', Component: EmailNotificationsTab },
  { id: 'email-templates', label: 'Email templates', Component: EmailTemplatesTab },
];

function TabsNav({ activeId, onSelect }) {
  return (
    <aside className="lg:w-[240px] lg:shrink-0 rounded-2xl bg-white border border-[#ECE6FA] p-2 lg:p-3 h-fit">
      <nav className="flex lg:flex-col gap-1 overflow-x-auto zara-scroll lg:overflow-visible">
        {TABS.map((t) => (
          <button
            key={t.id}
            onClick={() => onSelect(t.id)}
            className={`shrink-0 lg:w-full text-left px-3 py-2.5 rounded-lg text-[13px] lg:text-[13.5px] whitespace-nowrap transition-colors ${
              activeId === t.id
                ? 'bg-[#F1ECFE] text-[#5B4FE8] font-semibold'
                : 'text-[#1A1533] hover:bg-[#FAF8FF] font-medium'
            }`}
          >
            {t.label}
          </button>
        ))}
      </nav>
      <div className="hidden lg:block mt-4 px-3 py-2 text-[12px] text-[#5B4FE8] font-semibold hover:underline cursor-pointer">
        Terms and conditions
      </div>
    </aside>
  );
}

export default function Settings() {
  const navigate = useNavigate();
  const [tabId, setTabId] = useState('ai-interviewer');
  const Active = TABS.find((t) => t.id === tabId)?.Component || AIInterviewerTab;

  return (
    <div className="flex min-h-screen bg-[#F7F5FF]">
      <Sidebar />
      <main className="flex-1 flex flex-col min-w-0">
        <MobileTopBar title="Settings" />
        <div className="px-5 md:px-10 pt-6 md:pt-8 pb-4">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-1 text-[13px] text-[#4A4463] hover:text-[#1A1533]"
          >
            <ChevronLeft size={14} /> Back
          </button>
          <h1 className="text-[22px] md:text-[28px] font-bold text-[#1A1533] tracking-tight mt-2">
            Settings
          </h1>
        </div>

        <div className="px-5 md:px-10 pb-10 flex flex-col lg:flex-row gap-4 lg:gap-6">
          <TabsNav activeId={tabId} onSelect={setTabId} />
          <section className="flex-1 rounded-2xl bg-white border border-[#ECE6FA] p-5 md:p-6 min-h-[520px] min-w-0">
            <Active />
          </section>
        </div>
      </main>
    </div>
  );
}
